import ptDashboard from './dashboard/dashboard.json'
import ptStats from './stats/stats.json'
import ptAccreditation from './accreditation/accreditation.json'
import ptCms from './cms/cms.json'
import ptAuth from './auth/auth.json'
import ptCommon from './common/common.json'
import ptCompetition from './competition/competition.json'
import ptGeneralApplications from './general-applications/general-applications.json'
import ptLeague from './league/league.json'
import ptMatch from './match/match.json'
import ptNotification from './notification/notification.json'
import ptOrganization from './organization/organization.json'
import ptPhase from './phase/phase.json'
import ptRecreation from './recreation/recreation.json'
import ptRoles from './roles/roles.json'
import ptSeason from './season/season.json'
import ptShared from './shared/shared.json'
import ptSponsor from './sponsor/sponsor.json'
import ptSport from './sport/sport.json'
import ptUnit from './unit/unit.json'
import ptUser from './user/user.json'
import ptUtils from './utils/utils.json'

export const pt = {
    dashboard: ptDashboard,
    stats: ptStats,
    common: ptCommon,
    accreditation: ptAccreditation,
    notification: ptNotification,
    league: ptLeague,
    roles: ptRoles,
    season: ptSeason,
    sponsor: ptSponsor,
    unit: ptUnit,
    sport: ptSport,
    user: ptUser,
    organization: ptOrganization,
    shared: ptShared,
    competition: ptCompetition,
    'general-applications': ptGeneralApplications,
    utils: ptUtils,
    phase: ptPhase,
    auth: ptAuth,
    match: ptMatch,
    recreation: ptRecreation,
    cms: ptCms,
}
